<template>
  <RecommendationCarousel
    :recommendation-query="{
      widgetId: widgetId,
      limit: 16,
      personalisation: true,
    }"
    :subtitle="subtitle"
    :title="title"
    :tracking-data="{
      list: pageName,
    }"
    @error="onCarouselNoResults"
    @no-results="onCarouselNoResults"
  />
  <CTALink class="w-full md:ml-auto md:block md:w-auto" :cta-link="ctaLink" />
</template>

<script setup lang="ts">
import type { CTALink as CTALinkType } from '@backmarket/http-api/src/api-specs-content/models/cta-link'

import RecommendationCarousel from '~/scopes/recommendation/components/RecommendationCarousel.vue'
import { usePageReference } from '~/scopes/recommendation/composables/useProductTracking'

import type { ContentBlockProps } from '../../models/content-block'
import CTALink from '../../shared-components/CTALink/CTALink.vue'

const pageName = usePageReference()
type RecommendationsProps = {
  widgetId: string
  title?: string
  subtitle?: string
  ctaLink?: CTALinkType
}

defineProps<ContentBlockProps & RecommendationsProps>()

const emit = defineEmits(['error'])

const onCarouselNoResults = () => {
  emit('error')
}
</script>
